import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { sessionUserHasRolePrivileges } from '../../utility/SecurityRules';
import { selectSessionInformation } from '../../redux/slices/sessionSlice';

function HasRolePrivileges(props) {
  const {
    children,
    targetRoleList,
    alternativeComponent,
    ...otherProps
  } = props;
  const { activeSubscription } = useSelector(selectSessionInformation);
  // pass props down to children
  // after filtering out the props from this component that we don't want
  const extendedChildren = React.Children.map(
    children, (child, index) => React.cloneElement(child, { ...otherProps, key: index }),
  );
  return (sessionUserHasRolePrivileges(activeSubscription, targetRoleList)
    ? <>{extendedChildren}</>
    : alternativeComponent);
}

HasRolePrivileges.defaultProps = {
  alternativeComponent: (<></>),
};

HasRolePrivileges.propTypes = {
  targetRoleList: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string,
    id: PropTypes.number,
  })).isRequired,
  alternativeComponent: PropTypes.element,
};

export default HasRolePrivileges;
